import { render, staticRenderFns } from "./CallConfig.vue?vue&type=template&id=3ae69b76&scoped=true&"
import script from "./CallConfig.vue?vue&type=script&lang=js&"
export * from "./CallConfig.vue?vue&type=script&lang=js&"
import style0 from "./CallConfig.vue?vue&type=style&index=0&id=3ae69b76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae69b76",
  null
  
)

export default component.exports